import React from 'react'
import { Button, Card, Modal, Grid, Image, Icon, Message } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class DeleteUserFromUnit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: ''
        }
        this.delUserFromSubOrg = this.delUserFromSubOrg.bind(this);
    }

    deleteUserClose() {
        dispatch.users.userDelModalOpen(false);
        dispatch.users.addUserToDelete({});
    }

    async delUserFromSubOrg() {
        let payload;
        if (this.props.userToDel.type === 'deleteUserFromUserResourcepane' || this.props.userToDel.type === 'userTeamsListView' || this.props.userToDel.type === 'deleteUserFromToolbar') {
            payload = {
                accountUserId: this.props.userToDel._id,
                email: this.props.userToDel.email,
                organizationId: this.props.selectedOrganisation.id,
                accountId: this.props.selectedAccount._id,
                teamId: this.props.userToDel.subOrgId
            }
        }
        else if (this.props.userToDel.type === 'deleteUserFromTeamResourcepane') {
            payload = {
                accountUserId: this.props.userToDel.accountUserId._id,
                email: this.props.userToDel.accountUserId.email,
                organizationId: this.props.selectedOrganisation.id,
                accountId: this.props.selectedAccount._id,
                teamId: this.props.selectedSubOrg._id
            }
        }
        else {
            payload = {
                accountUserId: this.props.userToDel.accountUserId._id,
                email: this.props.userToDel.accountUserId.email,
                organizationId: this.props.selectedOrganisation.id,
                accountId: this.props.selectedAccount._id,
                teamId: this.props.selectedSubOrg._id
            }
        }
        try {
            await dispatch.users.deleteUserInTeam(payload);
            if (this.props.userToDel.type === 'deleteUserFromUserResourcepane') {
                for (let i = this.props.userObj.subOrgIdArr.length; i--;) {
                    if (this.props.userObj.subOrgIdArr[i].subOrgId === this.props.userToDel.subOrgId) {
                        let indexToSplice = this.props.userObj.subOrgIdArr.indexOf(this.props.userObj.subOrgIdArr[i]);
                        await this.props.userObj.subOrgIdArr.splice(indexToSplice, 1);
                        break;
                    }
                }

                for (let i = this.props.usersList.length; i--;) {
                    if (this.props.usersList[i]._id === this.props.userToDel._id) {
                        let indexToSplice = this.props.usersList.indexOf(this.props.usersList[i]);
                        this.props.usersList[indexToSplice].subTeamCount = this.props.usersList[indexToSplice].subTeamCount - 1;
                        break;
                    }
                }

            }
            else if (this.props.userToDel.type === 'userTeamsListView') {
                for (let i = this.props.userSuborganizationList.length; i--;) {
                    if (this.props.userSuborganizationList[i].subOrgId === this.props.userToDel.subOrgId) {
                        let indexToSplice = this.props.userSuborganizationList.indexOf(this.props.userSuborganizationList[i]);
                        await this.props.userSuborganizationList.splice(indexToSplice, 1);
                        break;
                    }
                }
            }
            else if (this.props.userToDel.type === 'deleteUserFromToolbar') {
                await dispatch.organizationTab.getUsersTreeAsync({ id: payload.teamId, accountId: payload.accountId });
                dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                dispatch.organizationUnit.showResourecePane(null);
            }
            else if (this.props.userToDel.type === 'deleteUserFromTeamResourcepane') {
                for (let i = this.props.teamUsersArray.length; i--;) {
                    if (this.props.teamUsersArray[i].accountUserId._id === this.props.userToDel.accountUserId._id) {
                        let indexToSplice = this.props.teamUsersArray.indexOf(this.props.teamUsersArray[i]);
                        await this.props.teamUsersArray.splice(indexToSplice, 1);
                        break;
                    }
                }

                for (let i = this.props.subOrgs.data.length; i--;) {
                    if (this.props.subOrgs.data[i]._id.toString() === this.props.selectedSubOrg._id.toString()) {
                        let index = this.props.subOrgs.data.indexOf(this.props.subOrgs.data[i]);
                        this.props.subOrgs.data[index].userCounts -= 1;
                        break;
                    }
                }
               
            }
            await dispatch.users.userDelModalOpen(false);
            dispatch.organizationUnit.showDeleteDisabled(false)
        }
        catch (err) {
            this.setState({ errorMsg: err.message })
        }

    }

    render() {
        const inlineStyle = {
            modal: {
                marginTop: '100px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        return (
            <Modal
                className="removeUserModal"
                size='small'
                open={this.props.userDelModalOpen}
                centered
                style={inlineStyle.modal}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Form noValidate
                    ref={ref => this.form = ref}
                    className="formcyForm"
                    onValidSubmit={this.delUserFromSubOrg}
                >
                    <Grid className="deleteUserfromUnit" >
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <h4>Remove Member from Team {this.props.selectedTeamName}</h4>
                                <Grid>
                                    <Grid.Column width={3} style={{ margin: "0 0 10px  0" }}>
                                        {this.props.userToDel.type === 'deleteUserFromUserResourcepane' || this.props.userToDel.type === 'userTeamsListView' || this.props.userToDel.type === 'deleteUserFromToolbar' ?
                                            <ImageAvater user={this.props.userToDel} className="w_32 h_32 mar_5" imageStyle="w_32 h_32 mar_5" />
                                            :
                                            <ImageAvater user={this.props.userToDel.accountUserId} className="w_32 h_32 mar_5" imageStyle="w_32 h_32 mar_5" />
                                        }

                                    </Grid.Column>
                                    {this.props.userToDel.type === 'deleteUserFromUserResourcepane' || this.props.userToDel.type === 'userTeamsListView' || this.props.userToDel.type === 'deleteUserFromToolbar' ?
                                        <Grid.Column width={13} className="memberInfo">
                                            <Card.Header>{this.props.userToDel.firstName + ' ' + this.props.userToDel.lastName}</Card.Header>
                                            <Card.Meta className="email" content={this.props.userToDel.email} />
                                            <Card.Meta className="role" content={this.props.userToDel.role} />

                                        </Grid.Column> :
                                        <Grid.Column width={13} className="memberInfo">
                                            <Card.Header>{this.props.userToDel.accountUserId.firstName + ' ' + this.props.userToDel.accountUserId.lastName}</Card.Header>
                                            <Card.Meta className="email" content={this.props.userToDel.accountUserId.email} />
                                            <Card.Meta className="role" content={this.props.userToDel.role} />

                                        </Grid.Column>}

                                </Grid>
                            </Grid.Column>
                            <Grid.Column>
                                <h4>Current Team and Role</h4>
                                <div className="currentUserAndRole">
                                    <div >
                                        <Icon name="group" />
                                        <span>{this.props.selectedTeamName}</span>
                                    </div>
                                    <div>
                                        <Icon name="user" />
                                        <span>{this.props.userToDel.role}</span>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>

                        {!this.state.errorMsg ?
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <p>Are you sure you want to remove this user?
                            <span className="actionTag"> This action is not reversible</span>
                                    </p>
                                </Grid.Column>
                            </Grid.Row> : ''}
                        {this.state.errorMsg ?
                            <Grid.Row>
                                <Message color='yellow'
                                    className="inviteWarning"
                                    content={this.state.errorMsg}
                                />
                            </Grid.Row>
                            : ''
                        }
                        <Grid.Row columns={1}>
                            <Grid.Column>
                                {this.state.errorMsg ? '' :
                                    <Button floated='right' className="bg-clr-orange bg-blue" type="cancel" id="cancel">Remove</Button>
                                }
                                <Button floated='right' className="bg-clr-gray " type="submit" id="submit" onClick={this.deleteUserClose}>Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>

                    </Grid>
                </Form >

            </Modal>
        )
    }

}

export default DeleteUserFromUnit;